module.exports = __webpack_public_path__ + "img/w27-b3.94056d1f.jpg";